import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "./slices/loginModal/modalSlice";
import pendingService from "./slices/pendingService/pendingServiceSlice";
import footerSlice from "./slices/footer/footerSlice";
import popUpSlice from "./slices/popUp/popUpSlice";
import userSLice from "./slices/user/userSlice";
import headerSlice from "./slices/header/headerSlice";
import paymentSlice from "./slices/payment/paymentSlice";
import pageDataSlice from "./slices/pageData/pageDataSlice";
import searchSlice from "./slices/search/searchSlice";

const store = configureStore({
  reducer: {
    modal: modalReducer,
    pendingService,
    footer: footerSlice,
    popUp: popUpSlice,
    user: userSLice,
    header: headerSlice,
    payment: paymentSlice,
    pageData: pageDataSlice,
    search: searchSlice,
  },
});

export default store;
